import { CommodityComplexFilterInput, MapMarker, MapMarkersPayload, MarkerType } from '@bechtel/types';
import { useLazyQuery, QueryTuple } from '@apollo/client';
import {
  FWE_MAP_MARKERS_QUERY,
  FWE_FITUP_MAP_MARKERS_QUERY,
  FWE_APPROVED_MAP_MARKERS_QUERY,
  MAP_MARKERS_QUERY,
} from '@bechtel/client-gql';

export function useFweMapMarkersQuery(
  onActionCompleted?: (result: any) => void
): QueryTuple<{ mapMarkersPayload: MapMarkersPayload }, { input: CommodityComplexFilterInput; types: MarkerType }> {
  const response = useLazyQuery<
    { mapMarkersPayload: MapMarkersPayload },
    { input: CommodityComplexFilterInput; types: MarkerType }
  >(FWE_MAP_MARKERS_QUERY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first',
    onCompleted: (result) => {
      if (onActionCompleted) onActionCompleted(result);
    },
    onError: (result) => {
      if (onActionCompleted) onActionCompleted(result);
    },
  });
  return response;
}

export function useFweFitupMapMarkersQuery(
  onActionCompleted?: (result: any) => void
): QueryTuple<{ mapMarkersPayload: MapMarkersPayload }, { input: CommodityComplexFilterInput; types: MarkerType }> {
  const response = useLazyQuery<
    { mapMarkersPayload: MapMarkersPayload },
    { input: CommodityComplexFilterInput; types: MarkerType }
  >(FWE_FITUP_MAP_MARKERS_QUERY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first',
    onCompleted: (result) => {
      if (onActionCompleted) onActionCompleted(result);
    },
    onError: (result) => {
      if (onActionCompleted) onActionCompleted(result);
    },
  });
  return response;
}

export function useFweApprovedMapMarkersQuery(
  onActionCompleted?: (result: any) => void
): QueryTuple<{ mapMarkersPayload: MapMarkersPayload }, { input: CommodityComplexFilterInput; types: MarkerType }> {
  const response = useLazyQuery<
    {
      mapMarkersPayload: MapMarkersPayload;
    },
    { input: CommodityComplexFilterInput; types: MarkerType }
  >(FWE_APPROVED_MAP_MARKERS_QUERY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first',
    onCompleted: (result) => {
      if (onActionCompleted) onActionCompleted(result);
    },
    onError: (result) => {
      if (onActionCompleted) onActionCompleted(result);
    },
  });
  return response;
}

export function useMapMarkersQuery(
  onActionCompleted?: (result: any) => void
): QueryTuple<{ mapMarkersPayload: MapMarkersPayload }, { input: CommodityComplexFilterInput; types: MarkerType }> {
  const response = useLazyQuery<
    {
      mapMarkersPayload: MapMarkersPayload;
    },
    {
      input: CommodityComplexFilterInput;
      types: MarkerType;
    }
  >(MAP_MARKERS_QUERY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first',
    onCompleted: (result) => {
      if (onActionCompleted) onActionCompleted(result);
    },
    onError: (result) => {
      if (onActionCompleted) onActionCompleted(result);
    },
  });
  return response;
}
